import { IFile } from '@cyber-range/cyber-range-api-file-client';
import { defineStore } from 'pinia';
import { useApiClientStore } from './apiClientStore';

export const useFileStore = defineStore('fileStore', 
{
    actions: 
    {
        async getOneDownloadUrl(fileId: string, options?: {background?: boolean}): Promise<IFile>
        {
            const client = options?.background ? useApiClientStore().backgroundFileApiClient : useApiClientStore().fileApiClient;

            return await client.getOneDownloadUrl(fileId);
        }
    }
});
